import {
  GetAssignmentsForAssigneeRequest,
  GetAssignmentsForAssigneeResponse,
} from '@eigtech/assignments-types'
import { contextualGet } from '@eigtech/ui-shared-api'
import { assignmentsBasePath } from './constants'

export const getAssignablesForAssignee = ({ assigneeId }: GetAssignmentsForAssigneeRequest) =>
  contextualGet<GetAssignmentsForAssigneeResponse>(`${assignmentsBasePath}/assignee/${assigneeId}`)
